import { ApiService } from '../apiService'
import {
  AdminThemeDto,
  CreateThemeRequest,
  UpdateThemeRequest,
  AwardThemeRequest,
  RevokeThemeRequest,
  AwardThemeResponse,
  RevokeThemeResponse,
} from '../types/themes'

export const themesApi = {
  getThemes: () =>
    ApiService.get<AdminThemeDto[]>('/admin/themes'),

  createTheme: (data: CreateThemeRequest) =>
    ApiService.post<AdminThemeDto>('/admin/themes', data),

  updateTheme: (id: string, data: UpdateThemeRequest) =>
    ApiService.put<AdminThemeDto>(`/admin/themes/${id}`, data),

  deleteTheme: (id: string) =>
    ApiService.delete<void>(`/admin/themes/${id}`),

  awardTheme: (id: string, data: AwardThemeRequest) =>
    ApiService.post<AwardThemeResponse>(`/admin/themes/${id}/award`, data),

  revokeTheme: (id: string, data: RevokeThemeRequest) =>
    ApiService.delete<RevokeThemeResponse>(`/admin/themes/${id}/revoke`, data),
}
